import { useQuery } from '@tanstack/react-query';
import { Axios } from '../axios';
const localData = JSON.parse(localStorage.getItem('user'));
let entityType = localData?.user?.entityType;

export const useGetActivities = (queryParams = '', options = {}) => {
  return useQuery({
    queryKey: ['getActivities', queryParams],
    queryFn: async () => {
      const result = await Axios.get(
        `${entityType}/activity-logs?${queryParams}`,
      );
      return result.data;
    },
    enabled: !!queryParams,
    ...options,
  });
};
